//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


const looseEqual = (a, b) => a == b;

export default {
  name: 'KSwitch',
  props: {
    name: String,
    label: String,
    tabindex: [String, Number],
    value: {
      type: Boolean,
      required: true,
    },
    trueValue: {
      type: Boolean,
      default: true,
    },
    falseValue: {
      type: Boolean,
      default: false,
    },
    submittedValue: {
      type: String,
      default: 'on', // HTML default
    },
    checked: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      // 'primary' by default, but could add more later
      default: 'primary',
    },
    switchPosition: {
      type: String,
      default: 'left', // 'left' or 'right'
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isActive: false,
      isChecked: looseEqual(this.value, this.trueValue) || this.checked,
    };
  },
  computed: {
    classes() {
      return [
        `k-switch--color-${this.color}`,
        `k-switch--switch-position-${this.switchPosition}`,
        { 'is-active': this.isActive },
        { 'is-checked': this.isChecked },
        { 'is-disabled': this.disabled },
        { 'is-rtl': this.isRtl },
      ];
    },
  },
  watch: {
    value() {
      this.isChecked = looseEqual(this.value, this.trueValue);
    },
  },
  created() {
    this.$emit('input', this.isChecked ? this.trueValue : this.falseValue);
  },
  methods: {
    onClick(e) {
      const isCheckedPrevious = this.isChecked;
      const isChecked = e.target.checked;
      this.$emit('input', isChecked ? this.trueValue : this.falseValue, e);
      if (isCheckedPrevious !== isChecked) {
        this.$emit('change', isChecked ? this.trueValue : this.falseValue, e);
      }
    },
    onFocus(e) {
      this.isActive = true;
      this.$emit('focus', e);
    },
    onBlur(e) {
      this.isActive = false;
      this.$emit('blur', e);
    },
  },
};

